import request from "../utils/fetch";
import axios from "axios";
import store from "@/store";
// const request = axios.create({
//   baseURL: "/dataAnalysis"
// });
// request.interceptors.request.use(function(config) {
//   config.headers["Authorization"] =
//     "WLXS" + " " + store.getters.get_token.access_token;
//   config.headers["Accept"] = "application/json";
//   config.headers["platform"] = "PC";
//   config.headers["mr-future.2022-key"] = "value-2022.mr-future";
//   config.headers["SystemUpdate"] = 1;
//   return config;
// });
//
// request.interceptors.response.use(response => {
//   return response.data;
// });
export function deepseek(data) {
  return request({
    url: "/analysis/handler/deepseek",
    method: "post",
    requestBody: "body",
    loading: true,
    data: data
  });
}
//数据分析
export function create_record(data) {
  return request({
    url: "/analysis/handler/create_record",
    method: "post",
    requestBody: "body",
    loading: true,
    data: data
  });
}
export function list(data) {
  return request({
    url: "/analysis/record/list",
    method: "post",
    requestBody: "body",
    loading: true,
    data: data
  });
}

export function updateReadStatus(data) {
  return request({
    url: "/analysis/record/updateReadStatus",
    method: "get",
    requestBody: "query",
    loading: true,
    params: data
  });
}
///查询指定分区售水机设备列表
export function equipmentList(data) {
  return request({
    url: "/analysis/ssj/equipment/list",
    method: "get",
    requestBody: "query",
    loading: true,
    params: data
  });
}
